import { Card } from "@/shared/components/ui/card"

export function TerminosCondicionesPage() {
  return (
    <div className="pt-32 pb-20 lg:pt-40 lg:pb-32">
      <div className="container mx-auto px-4 lg:px-8 max-w-8xl">
        <h1 className="text-4xl lg:text-6xl font-bold mb-8">Términos y Condiciones</h1>

        <Card className="p-8 lg:p-12 space-y-8">
          <section className="space-y-4">
            <h2 className="text-2xl font-bold">1. Aceptación de los Términos y Condiciones:</h2>
            <p className="text-xl-foreground leading-relaxed">
              Al acceder y utilizar los servicios de Rapyfact, el usuario acepta estar sujeto a estos Términos y Condiciones.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-3xl font-bold">2. Definiciones:</h2>
            <ul className="list-disc list-inside space-y-2 text-xl-foreground leading-relaxed">
              <li>“Servicios” se refiere a la facturación electrónica, gestión de datos, manejo de archivos RIPS y validación de archivos JSON, según las normas de la DIAN y SISPRO.</li>
              <li>“Usuario” se refiere a cualquier persona que acceda y utilice los servicios de Rapyfact.</li>
            </ul>
  
          </section>

          <section className="space-y-4">
            <h2 className="text-3xl font-bold">3. Uso de los Servicios:</h2>
            <p className="text-xl-foreground leading-relaxed">
              El usuario se compromete a utilizar los servicios de Rapyfact de manera lícita y ética, y a cumplir con todas las leyes y regulaciones aplicables.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-3xl font-bold">4. Propiedad Intelectual:</h2>
            <p className="text-xl-foreground leading-relaxed">
              Todos los derechos de propiedad intelectual de Rapyfact, incluyendo pero no limitado a, software, algoritmos, diseños y marcas comerciales, son propiedad exclusiva de Valerosas Tech S.A.S.
            </p>
          </section>
          <section className="space-y-4">
            <h2 className="text-3xl font-bold">5. Limitación de Responsabilidad:</h2>
            <p className="text-xl-foreground leading-relaxed">
              Aunque Rapyfact se esfuerza por proporcionar servicios de alta calidad, no podemos garantizar que los servicios estén libres de errores o interrupciones. Sin embargo, nos comprometemos a proporcionar un servicio de soporte de calidad para ayudar a nuestros clientes a resolver cualquier problema o inquietud que puedan tener.
            </p>
          </section>
          <section className="space-y-4">
            <h2 className="text-3xl font-bold">6. Seguridad y Privacidad:</h2>
            <p className="text-xl-foreground leading-relaxed">
             Rapyfact se compromete a mantener la seguridad y privacidad de la información del usuario, de acuerdo con las leyes y regulaciones aplicables.
            </p>
          </section>
          <section className="space-y-4">
            <h2 className="text-3xl font-bold">7. Cancelaciones y Reembolsos:</h2>
            <ul className="list-disc list-inside space-y-2 text-xl-foreground leading-relaxed">
              <li>Los usuarios pueden solicitar la cancelación de los servicios en cualquier momento, enviando una notificación formal a nuestro equipo de soporte.</li>
              <li>No se otorgarán reembolsos por servicios ya prestados o facturas ya emitidas.</li>
              <li>En caso de errores atribuibles a Rapyfact, evaluaremos la situación y podrá ofrecerse un reembolso parcial o crédito para servicios futuros.</li>
            </ul>
  
          </section>
          <section className="space-y-4">
            <h2 className="text-3xl font-bold">8. Soporte Técnico:</h2>
            <ul className="list-disc list-inside space-y-2 text-xl-foreground leading-relaxed">
              <li>Rapyfact ofrece soporte técnico a través de correo electrónico, chat en vivo y otros canales establecidos.</li>
              <li>El tiempo de respuesta puede variar según la complejidad del problema, pero nos comprometemos a atender todas las solicitudes en el menor tiempo posible.</li>
            </ul>
          </section>
          <section className="space-y-4">
            <h2 className="text-3xl font-bold">9. Cambios en los Términos y Condiciones:</h2>
            <p className="text-xl-foreground leading-relaxed">
              Los presentes términos y condiciones podrán ser modificados, actualizados o reemplazados en cualquier momento, a discreción exclusiva del proveedor del software, conforme a lo dispuesto en la página oficial de condiciones del servicio. Se recomienda al usuario revisar periódicamente dicha página para mantenerse informado sobre posibles cambios.
            </p>
          </section>
          <section className="space-y-4">
            <h2 className="text-3xl font-bold">10. Ley Aplicable:</h2>
            <p className="text-xl-foreground leading-relaxed">
             Estos Términos y Condiciones se regirán e interpretarán de acuerdo con las leyes de la República de Colombia.
             De conformidad con la Ley 1581 de 2012, garantizamos la protección de los datos personales de nuestros usuarios. Puedes consultar nuestra Política de Privacidad para más detalles sobre cómo manejamos la información.
            </p>
          </section>
          <section className="space-y-4">
            <h2 className="text-3xl font-bold">11. Jurisdicción:</h2>
            <p className="text-xl-foreground leading-relaxed">
             Cualquier disputa o reclamación que surja de estos Términos y Condiciones se resolverá a través de los tribunales competentes de la República de Colombia.
            </p>
          </section>
          <section className="space-y-4">
            <h2 className="text-3xl font-bold">12. Clausula de derecho de uso de licencia de la plataforma, certificado de firma digital, conservación en la nube de CUV y custodia de documentos electrónicos:</h2>
            <p className="text-xl-foreground leading-relaxed">
              Estimado cliente te informamos que los planes de suscripción se renuevan automáticamente de forma mensual para garantizarte los beneficios de uso de la plataforma. Si desea la baja del servicio por favor informarnos a soporte@rapyfact.com la no continuidad correspondiente (suscripción sin pagar 15 días posteriores a la fecha de renovación será automáticamente proporcionado el acceso a la plataforma solo modo lectura , sin creaciones, ediciones, impresiones ni descargar disponibles). Estamos para servirles
            </p>
          </section>
        </Card>
      </div>
    </div>
  )
}
